import React from 'react';
import Highcharts from 'react-highcharts';

const ProficienciaLineChart = ({ data }) => {

  const datachart = data && data.map((item) => ({
    prova: item.ds_periodo,
    nota: parseFloat(item.NT_ALUNO),
    cor: item.cor,
  })); 
  
  const config = {
    title: {
      text: '',
    },
    xAxis: {
      categories: datachart.map(item => item.prova),
    },
    yAxis: {
      title: {
        text: 'Proficiência',
      },
    },
    series: [
      {
        name: 'Proficiência',
        data: datachart.map(item => ({
          y: item.nota,
          color: item.cor,
        })),
        showInLegend: false,
        marker: {
          enabled: true,
          radius: 10,
        },
      },
    ],
  };
  return (
    <div style={{ height: 'auto', width: '100%', borderRadius: '12px' }}>
      <Highcharts config={config} style={{ borderRadius: '30px' }} />
    </div>
  );
};
export default ProficienciaLineChart;